
class CountryRegModal {
	
	constructor() {

		$("#editCountryRegModal button.btn-primary").click(e => {
			e.preventDefault();

			let langs = $("#country_languages").val();
			let ed = $("#country_current_edition").val();

			let id = $("#editCountryRegModal").data("id");

			$.ajax({data:{op:"updateCountryReg", id: id, langs: langs, edition: ed}});

		});

	}

}

export default CountryRegModal;